import { YDocProvider } from '@y-sweet/react'

import { getClientToken } from '@pepper/utils/src/api/editor/editor'

interface Props {
  useYjsV2?: boolean
  docId: string
  editorType: PepperDocTypes
  children: React.ReactNode
}

// wraps children in YDocProvider for v2 yjs documents.
// passes through unchanged for v1 / non-yjs docs.
// mounted ABOVE the topbar so usePresence works in collaboration UI.
//
// getClientToken internally waits for useEditorStore to be seeded by
// EditorRootWithToken before firing — y-sweet's first authEndpoint call
// races the child effect that populates the store.
export default function DocV2Provider({
  useYjsV2,
  docId,
  editorType,
  children,
}: Props): JSX.Element {
  if (!useYjsV2) return <>{children}</>
  return (
    <YDocProvider
      docId={docId}
      authEndpoint={() => getClientToken(docId, editorType)}
      showDebuggerLink={false}
    >
      {children}
    </YDocProvider>
  )
}
